import Link from 'next/link';
import Image from 'next/image';
import { Instagram, Facebook } from 'lucide-react';

export function Footer() {
  return (
    <footer className="border-t border-border/40 bg-card mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About */}
          <div>
            <Image
              src="/images/logo.jpg"
              alt="Crudo e Vino - Enoteca SUD"
              width={180}
              height={72}
              className="h-14 w-auto mb-4"
            />
            <p className="text-sm text-muted-foreground leading-relaxed">
              Authenticité italienne au cœur de Differdange. Cuisine italienne
              contemporaine et vins d&apos;exception.
            </p>
          </div>

          {/* Contact & Hours */}
          <div>
            <h3 className="font-semibold mb-4">Contact</h3>
            <div className="space-y-2 text-sm text-muted-foreground">
              <p>Auchan Opkorn</p>
              <p>1 boulevard Émile Krieps</p>
              <p>L-4622 Differdange, Luxembourg</p>
              <p className="mt-4">
                <a href="tel:+35227521531" className="hover:text-primary transition-colors">
                  +352 2 752 1531
                </a>
              </p>
              <p>
                <a href="mailto:liminalux@outlook.com" className="hover:text-primary transition-colors">
                  liminalux@outlook.com
                </a>
              </p>
              <p className="mt-4 text-xs">
                <span className="text-secondary font-semibold">Horaires :</span> Lundi au samedi, 10h - 22h30<br />
                Cuisine continue • Parking gratuit 2h
              </p>
            </div>
          </div>

          {/* Legal & Social */}
          <div>
            <h3 className="font-semibold mb-4">Suivez-nous</h3>
            <div className="flex gap-4 mb-6">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-muted flex items-center justify-center hover:bg-primary transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-muted flex items-center justify-center hover:bg-primary transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
            </div>
            <div className="space-y-2 text-sm text-muted-foreground">
              <Link href="/mentions-legales" className="block hover:text-primary transition-colors">
                Mentions Légales
              </Link>
              <Link href="/confidentialite" className="block hover:text-primary transition-colors">
                Confidentialité
              </Link>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-border/40 text-center text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} Crudo e Vino. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
}
